import { DentistProfileService } from '../../shared/services/dentist-profile.service';
import { MyCommonService } from "./my-common.service";
import { environment } from "../../../environments/environment.prod";
import { BehaviorSubject } from "rxjs";
import {Injectable, Inject, PLATFORM_ID} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from 'rxjs/operators';
import { SweetAlert } from "../../shared/sweet-alert";
import {isPlatformBrowser} from "@angular/common";
let swal = SweetAlert.swal;
let sweetAlert = SweetAlert.swal;
declare var $: any;
@Injectable({
  providedIn: "root"
})

export class GlobalServiceService {

  is_front_logged = new BehaviorSubject<Number>(0);
  is_switch_acc = new BehaviorSubject<Number>(0);
  showLoader = new BehaviorSubject<number>(0);
  base_url = `${environment.apiURL}/`;
  $on = new BehaviorSubject<any>("");
  curr_state = new BehaviorSubject<any>("");
  activename: any = new BehaviorSubject<any>("");
  promoPage: any = new BehaviorSubject<any>("");
  show_message: any = new BehaviorSubject<any>("");
  showErrMsg: any = new BehaviorSubject<any>("");
  loginType: any = new BehaviorSubject<any>("");
  mydentistid: any = new BehaviorSubject<string>('');
  logged_user_name: any = new BehaviorSubject<string>('');
  user_profile_pics: any = new BehaviorSubject<any>("");
  showRefresh: any = new BehaviorSubject<any>("");
  profile_image: any = new BehaviorSubject<any>("");
  logged_user_id: any = new BehaviorSubject<any>("");
  logged_user_email: any = new BehaviorSubject<any>("");
  user_temp_pics: any = new BehaviorSubject<any>("");
  make_profile_url: any = new BehaviorSubject<any>("");
  access_token: any = new BehaviorSubject<any>("");
  step2: any = new BehaviorSubject<any>("");
  step3: any = new BehaviorSubject<any>("");
  step4: any = new BehaviorSubject<any>("");
  step5: any = new BehaviorSubject<any>("");
  step6: any = new BehaviorSubject<any>("");
  step7: any = new BehaviorSubject<any>("");

  reg_success_msg1: any = new BehaviorSubject<any>("");
  reg_success_msg2: any = new BehaviorSubject<any>("");

  change_color: any = new BehaviorSubject<any>("");
  show_message_email: any = new BehaviorSubject<any>("");
  showSuccMsg: any = new BehaviorSubject<any>("");
  show_my_message: any = new BehaviorSubject<any>("");
  showSuccessMsg: any = new BehaviorSubject<any>("");
  reg_success_msg: any = new BehaviorSubject<any>("");

  obj: any = new BehaviorSubject<any>("");
  showErrMsgFrgt: any = new BehaviorSubject<any>("");
  post_id: any = new BehaviorSubject<any>("");
  hasPost: any = new BehaviorSubject<any>("");
  showErrMsgVar: any = new BehaviorSubject<any>("");
  show_class: any = new BehaviorSubject<any>("");
  show_messagevar: any = new BehaviorSubject<any>("");
  show_email_validation: any = new BehaviorSubject<any>("");
  mypost: any = new BehaviorSubject<any>("");
  hideChangePasswordFB: any = new BehaviorSubject<any>("");
  dentist_profile_pic: any = new BehaviorSubject<any>("");
  interval_refresh: any = new BehaviorSubject<any>("");
  checkPayload;
  patientlogoutPayload;
  DentistlogoutPayload;
  paidPlanExist: any = new BehaviorSubject<any>("");
  hideFooterOnly = new BehaviorSubject<number>(0);
  mydentisturl;
  public postSearchData: string;
  private initialized = false;
    private localStorage: Storage = {
    getItem: () => "",
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
    length: 0,
    key: () => null,
  } satisfies Storage;
  private window: Window;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private myCommonService: MyCommonService,
    private router: Router,
    private dService: DentistProfileService
  ) {

    if (isPlatformBrowser(this.platformId)) {
      this.window = window;
      this.localStorage = window.localStorage;
      this.initializeService();
    }
  }

  private initializeService() {
    // Prevent multiple initializations
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    this.curr_state.next(this.router.url);
    this.is_front_logged.next(0);
    this.is_switch_acc.next(0);

    // Initialize user state from localStorage if available
    this.initializeUserState();
    
    this.mydentisturl = "";
  }

  private initializeUserState() {
    if (!this.myCommonService.isBrowser) {
      return;
    }

    // Batch localStorage reads to minimize DOM access
    const patientName = localStorage?.getItem("patientName");
    const mydentistid = localStorage?.getItem("mydentistid");
    const loginType = localStorage?.getItem("loginType");
    const patientImage = localStorage?.getItem("patientImage");
    const showRefresh = localStorage?.getItem("showRefresh");
    const userRole = localStorage?.getItem("userRole");
    const patientEmail = localStorage?.getItem("patientEmail");
    const dentistName = localStorage?.getItem("dentist_name");
    const dentistEmail = localStorage?.getItem("dentist_email");
    const isSwitchAcc = localStorage?.getItem("is_switch_acc");

    // Update subjects in batch
    if (patientName) this.logged_user_name.next(patientName);
    if (mydentistid) this.mydentistid.next(mydentistid);
    if (loginType) this.loginType.next(loginType);
    if (patientImage) this.user_profile_pics.next(patientImage);
    if (showRefresh) this.showRefresh.next(showRefresh);

    this.profile_image.next("");

    // Determine login state
    if (userRole === "4") {
      this.logged_user_name.next(patientName);
      this.is_front_logged.next(4);
      this.logged_user_email.next(patientEmail);
    } else if (userRole === "3") {
      this.logged_user_name.next(patientName);
      this.is_front_logged.next(3);
      this.logged_user_email.next(patientEmail);
    } else if (patientName) {
      this.logged_user_name.next(patientName);
      this.is_front_logged.next(2);
      this.logged_user_email.next(patientEmail);
    } else if (dentistName) {
      this.logged_user_email.next(dentistEmail);
      this.logged_user_name.next(dentistName);
      this.is_front_logged.next(1);
    }

    // Set switch account state
    if (isSwitchAcc === "1") {
      this.is_switch_acc.next(1);
    } else {
      this.is_switch_acc.next(0);
    }
  }

  globalRefresh(){
    swal(
    {
      title: "Something went wrong",
      text: " ",
      type: "warning",
      confirmButtonColor: "#0e6efd",
      confirmButtonText: " Reload page",
      closeOnConfirm: true,
    },
    isConfirm => {
      if (isConfirm) {
        location.reload();
      }
    });
  }

  //method patientLogout
  patientLogout() {

    var token = this.localStorage?.getItem("auth_token");
    var patient_id = this.localStorage?.getItem("patient_id");
    if (!patient_id) {
      //console.log('already logged out');
      this.router.navigate(["/"]);
      return;
    }
    if (this.interval_refresh) {
       clearInterval(this.interval_refresh);
    }
    var data = {
      patientId: patient_id,
      auth_token: token
    };
    var config = {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Token": token
      }
    };
    this.dService.PatientLogout(data, config).subscribe(data => {
        this.showLoader.next(0);
        this.patientlogoutPayload = data;
        if (this.patientlogoutPayload.status == 1) {
          this.mydentisturl = ""
          var domain = this.router.url.split('/');
            var slug = domain[1];
          if( typeof localStorage !== "undefined" && localStorage?.getItem("mydentistid")) {
            if(slug == 'customer') {
              this.mydentisturl = "/support/"+localStorage?.getItem("mydentistid")+"/customer-login"
            } else {
              this.mydentisturl = "/mydentist/"+localStorage?.getItem("mydentistid")+"/"+localStorage?.getItem("mydentistname")
            }
          }

          sessionStorage.clear();
          localStorage.clear();
          localStorage?.removeItem("auth_token");
          localStorage?.removeItem("patient_id");
          localStorage?.removeItem('patientName');
          localStorage?.removeItem('loginType');
          localStorage?.removeItem('patientImage');
          localStorage?.removeItem('patientEmail');
          localStorage?.removeItem("mydentistid")
          localStorage?.removeItem("mydentistname")
          localStorage?.removeItem("userRole"); //remove logged user role
          this.localStorage?.removeItem("id")
          this.localStorage?.removeItem("type")
          this.localStorage?.removeItem("is_switch_acc")
          this.is_front_logged.next(0);
          this.is_switch_acc.next(0);
          this.logged_user_name = new BehaviorSubject<any>("");
          // this.logged_user_name = '';
          if(this.router.url == this.mydentisturl){
            location.reload();
          }
          if(this.mydentisturl != ""){
            this.router.navigate([this.mydentisturl]);
          }else{
            this.router.navigate(["/"]);
          }
        } else {
          this.show_message = 'Something Wrong';
        }
      },
      error => {
        this.show_message = "Something is Wrong";
      }
    );

  }

  // method agent to dentist
  switchAgentToDentist() {
    var token = this.localStorage?.getItem("auth_token");
    var patient_id = this.localStorage?.getItem("patient_id");
    if (!patient_id) {
      this.router.navigate(["/"]);
      return;
    }
    var postData = {
      patient_id: patient_id,
      patient_token: token,
      auth_token: environment.authToken,
    };
    this.showLoader.next(1);

    // remove agent storage
    sessionStorage.clear();
    this.localStorage.clear();
    this.localStorage?.removeItem("auth_token");
    this.localStorage?.removeItem("patient_id");
    this.localStorage?.removeItem('patientName');
    localStorage?.removeItem('loginType');
    localStorage?.removeItem('patientImage');
    localStorage?.removeItem('patientEmail');
    localStorage?.removeItem("mydentistid")
    localStorage?.removeItem("mydentistname")
    localStorage?.removeItem("userRole"); //remove logged user role
    this.localStorage?.removeItem("id")
    this.localStorage?.removeItem("type")
    this.is_front_logged.next(0);

    this.dService.switchAgentToDentist(postData).subscribe(
      data => {
        this.showLoader.next(0);
        this.DentistlogoutPayload = data;
        if (this.DentistlogoutPayload.status == 1) {
          // set dentisi storage
          this.is_front_logged.next(1);
          this.is_switch_acc.next(1);
          this.localStorage.setItem("is_switch_acc", "1");
          this.localStorage.setItem("access_token", this.DentistlogoutPayload.data.token);
          this.localStorage.setItem("usr_info", this.DentistlogoutPayload.data.usr_info);
          this.localStorage.setItem("dentist_id", this.DentistlogoutPayload.data.user_id);
          this.localStorage.setItem("dentist_name", this.DentistlogoutPayload.data.name);
          this.localStorage.setItem("id", this.DentistlogoutPayload.data.user_id);
          this.localStorage.setItem("type", String(2));
          this.localStorage.setItem(
            "dentist_profile_pic",
            this.DentistlogoutPayload.data.final_profile_image
          );
          this.localStorage.setItem(
            "dentist_email",
            this.DentistlogoutPayload.data.email
          );
          this.logged_user_name.next(this.DentistlogoutPayload.data.name);
          this.user_profile_pics.next(this.DentistlogoutPayload.data.final_profile_image);
          //code to update dentist subscribed any plan or not
          this.paidPlanExist.next(this.DentistlogoutPayload.data.paid_pkg_exist);
          this.localStorage.setItem("dentist_payment_status", this.DentistlogoutPayload.data.payment_status);

         if(typeof window !== "undefined") window.location.href = '/dentist/messages'
          // this.router.navigateByUrl("/dentist/messages");
        } else if (this.DentistlogoutPayload.status == 5) {
          // location.reload();
        } else {
          // location.reload();
        }
      },
      error => {
        this.showLoader.next(0);
      }
    );

  }

  // method dentist to agent
  switchDentistToAgent() {
    var token = this.localStorage?.getItem("access_token");
    if (!token) {
      sessionStorage.clear();
      localStorage.clear();
      this.is_front_logged.next(0);
      this.is_switch_acc.next(0);
      this.logged_user_name = new BehaviorSubject<any>("");
      this.router.navigate(["/"]);
      return;
    }
    var postData: any = {
      web_token: this.localStorage?.getItem("web_token") ? this.localStorage?.getItem("web_token") : null,
      auth_token: environment.authToken,
      dentist_token: token
    };
    this.showLoader.next(1);

    // remove dentist storage
    sessionStorage.clear();
    this.localStorage.clear();
    this.localStorage?.removeItem("access_token");
    this.localStorage?.removeItem("usr_info");
    this.localStorage?.removeItem("patientName");
    this.localStorage?.removeItem("dentist_id");
    this.localStorage?.removeItem("dentist_profile_pic");
    this.localStorage?.removeItem("doct_id");
    this.localStorage?.removeItem("dentalPmsId");
    this.localStorage?.removeItem("dentist_email");
    this.localStorage?.removeItem("dentist_name");
    this.localStorage?.removeItem("id")
    this.localStorage?.removeItem("type");

    this.dService.switchDentistToAgent(postData).subscribe(
      data => {
        this.showLoader.next(0);
        this.DentistlogoutPayload = data;
        if (this.DentistlogoutPayload.status == 1) {
          // set vendor storage
          this.is_front_logged.next(3); //for agent
          this.localStorage.setItem("auth_token", this.DentistlogoutPayload.auth_token);
          this.localStorage.setItem("patient_id", this.DentistlogoutPayload.patient_id);
          this.localStorage.setItem("id", this.DentistlogoutPayload.patient_id_raw);
          this.localStorage.setItem("type", String(1));
          this.localStorage.setItem(
            "patient_id_raw",
            this.DentistlogoutPayload.patient_id_raw
          );
          this.localStorage.setItem(
            "patient_name",
            this.DentistlogoutPayload.patient_name
          );
          this.localStorage.setItem("patientImage", this.DentistlogoutPayload.profile_pic);
          this.localStorage.setItem("patientName", this.DentistlogoutPayload.patient_name);
          this.localStorage.setItem("loginType", this.DentistlogoutPayload.login_type);
          this.localStorage.setItem("userRole", String(3)); //for agent
          this.logged_user_name.next(this.DentistlogoutPayload.patient_name);
          this.user_profile_pics.next(this.DentistlogoutPayload.profile_pic);
          this.is_switch_acc.next(1);
          this.localStorage.setItem("is_switch_acc", "1");

         if(typeof window !== "undefined") window.location.href = '/marketplace/vendor/dashboard'
          // this.router.navigateByUrl("/marketplace/vendor/dashboard");

        } else if (this.DentistlogoutPayload.status == 5) {
          location.reload();
        } else {
          location.reload();
        }
      },
      error => {
        this.showLoader.next(0);
      }
    );

  }

  // method logout dentist
  logout() {
    var token = this.localStorage?.getItem("access_token");
    if (!token) {
      //start code add by vikas
      sessionStorage.clear();
      localStorage.clear();
      this.is_front_logged.next(0);
      this.is_switch_acc.next(0);
      this.logged_user_name = new BehaviorSubject<any>("");
      //end code add by vikas
      this.router.navigate(["/"]);
      return;
    }
    if (this.interval_refresh) {
      clearInterval(this.interval_refresh);
    }

    var postData: any = {
      web_token: this.localStorage?.getItem("web_token") ? this.localStorage?.getItem("web_token") : null
    };
    var config = {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Token": token
      }
    };

    this.dService.DentistLogout(postData, config).subscribe(data => {
        this.showLoader.next(0);
        this.DentistlogoutPayload = data;
        if (this.DentistlogoutPayload.status == 1) {
          sessionStorage.clear();
          this.localStorage.clear();
          this.localStorage?.removeItem("access_token");
          this.localStorage?.removeItem("usr_info");
          this.localStorage?.removeItem("patientName");
          this.is_front_logged.next(0);
          this.is_switch_acc.next(0);
          this.localStorage?.removeItem("patient_id");
          this.localStorage?.removeItem("patient_id_raw");
          this.localStorage?.removeItem("patient_name");
          this.localStorage?.removeItem("patientImage");
          this.localStorage?.removeItem("dentist_email");
          this.localStorage?.removeItem("dentist_name");
          this.localStorage?.removeItem("id")
          this.localStorage?.removeItem("type")
          this.localStorage?.removeItem("is_switch_acc")
          this.router.navigate(["/"]);
        } else {
          this.show_message = 'Something Wrong';
        }
      },
      error => {
        this.show_message = "Something is Wrong";
      }
    );

  }

  // method getUserSpecificInfo
  getUserSpecificInfo() {
    // var user_info = this.localStorage?.getItem("usr_info");
    // var user_array = new Array();
    // user_array = user_info.split("|@|");
    // var user_id = user_array[0];
    // var user_first_name = user_array[1];
    // var user_email = user_array[2];
    // var user_profile_pics = user_array[4];
    // var user_temp_pics = user_array[6];
    // var make_profile_url = user_array[5];
    // return [
    //   user_id,
    //   user_first_name,
    //   user_email,
    //   user_profile_pics,
    //   make_profile_url,
    //   user_temp_pics
    // ];
  }

  // method checkLastServieCallTimeAfterLogin
  checkLastServieCallTimeAfterLogin(specific_info?: any) {
    var token = this.localStorage?.getItem("access_token");
    var client_details = [];
    // client_details = /*$scope.getUserSpecificInfo*/this.getUserSpecificInfo();
    var config = {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Token': token,
      }
    };
  }

  angularForEach(values, func) {
    if (Array.isArray(values)) {
      values.forEach(func);
      return;
    }
    let keys = Object.keys(values);

    for (var i in keys) {
      let key = keys[i];
      let value = values[key];
      func(value, key);
    }
  }

  isDateValid(d) {
    let time = d.getTime();
    return !isNaN(time);
  }

  getUserProfile(){
    return this.user_profile_pics.asObservable();
  }

  getLoggedUser(){
    return this.logged_user_name.asObservable();
  }

  _scrollToTop() {
    if (this.myCommonService.isBrowser) {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
          this.window.scrollTo(0, 0);
        });
    }
  }

}
